var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createSlice } from '@reduxjs/toolkit';
export var initialState = {
    platform: '',
    alertType: '',
    profileLink: '',
    tokenId: '',
    apiHost: '',
    config: {
        hosts: undefined,
        apiErrorCallback: function () { return null; },
        lang: 'en'
    },
    accountsInfo: [],
    handleProfileClick: function () { return null; },
    hasAccountsDataLoaded: false
};
var appConfigSlice = createSlice({
    name: 'appConfig',
    initialState: initialState,
    reducers: {
        setAppConfig: function (state, _a) {
            var _b = _a.payload, platform = _b.platform, alertType = _b.alertType, profileLink = _b.profileLink, tokenId = _b.tokenId, apiHost = _b.apiHost, config = _b.config, accountsInfo = _b.accountsInfo, handleProfileClick = _b.handleProfileClick, hasAccountsDataLoaded = _b.hasAccountsDataLoaded;
            return __assign(__assign({}, state), { platform: platform, alertType: alertType, profileLink: profileLink, tokenId: tokenId, apiHost: apiHost, config: config, accountsInfo: accountsInfo, handleProfileClick: handleProfileClick, hasAccountsDataLoaded: hasAccountsDataLoaded });
        }
    }
});
export var setAppConfig = appConfigSlice.actions.setAppConfig;
export default appConfigSlice.reducer;
